import { useContext } from 'react';
import {
    TasksAndAlertsTeamActivityContext,
    TasksAndAlertsTeamActivityContextData
} from './context';

export function useTasksAndAlertsTeamActivity(): TasksAndAlertsTeamActivityContextData {
    const data = useContext<TasksAndAlertsTeamActivityContextData | undefined>(
        TasksAndAlertsTeamActivityContext
    );

    if (!data) {
        throw new Error(
            "TasksAndAlertsTeamActivityContext unavailable. Are you sure you're using this in a nested component of an TasksAndAlertsTeamActivityProvider?"
        );
    }

    return data;
}
